import { render } from "./rating_vietjet.vue?vue&type=template&id=db518454&scoped=true"
import script from "./rating_vietjet.vue?vue&type=script&lang=js"
export * from "./rating_vietjet.vue?vue&type=script&lang=js"

import "./rating_vietjet.vue?vue&type=style&index=0&id=db518454&scoped=true&lang=css"

import exportComponent from "/var/www/worldchatbox/node_build/worldchatbox_dev2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db518454"]])

export default __exports__